import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/Auth/AuthContext";

const useOnlineUsers = () => {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const { socket } = useContext(AuthContext);

  useEffect(() => {
    if (!socket || typeof socket.on !== 'function') {
      console.warn('useOnlineUsers: Socket não disponível ou sem método on');
      return;
    }

    const handleUsersOnline = (users) => {
      setOnlineUsers(users);
    };

    const handleUserOnline = ({ userId, lastSeen }) => {
      setOnlineUsers((prev) => {
        const userIndex = prev.findIndex((u) => u.id === userId);
        if (userIndex === -1) return prev;

        const updatedUsers = [...prev];
        updatedUsers[userIndex] = {
          ...updatedUsers[userIndex],
          online: true,
          lastSeen,
        };
        return updatedUsers;
      });
    };

    const handleUserOffline = ({ userId, lastSeen }) => {
      setOnlineUsers((prev) => {
        const userIndex = prev.findIndex((u) => u.id === userId);
        if (userIndex === -1) return prev;

        const updatedUsers = [...prev];
        updatedUsers[userIndex] = {
          ...updatedUsers[userIndex],
          online: false,
          lastSeen,
        };
        return updatedUsers;
      });
    };

    const handleUserNew = ({ user }) => {
      setOnlineUsers((prev) => {
        if (prev.some((u) => u.id === user.id)) return prev;
        return [...prev, { ...user, online: true }];
      });
    };

    try {
      socket.on("users:online", handleUsersOnline);
      socket.on("user:online", handleUserOnline);
      socket.on("user:offline", handleUserOffline);
      socket.on("user:new", handleUserNew);

      const heartbeatInterval = setInterval(() => {
        if (socket && typeof socket.emit === 'function') {
          socket.emit("heartbeat");
        }
      }, 15000);

      return () => {
        if (socket && typeof socket.off === 'function') {
          socket.off("users:online", handleUsersOnline);
          socket.off("user:online", handleUserOnline);
          socket.off("user:offline", handleUserOffline);
          socket.off("user:new", handleUserNew);
        }
        clearInterval(heartbeatInterval);
      };
    } catch (error) {
      console.error('Erro ao configurar listeners useOnlineUsers:', error);
    }
  }, [socket]);

  return onlineUsers;
};

export default useOnlineUsers;
